<template>
  <div class="layout-container interactive-map-traffic-container">
    <CustomSkeleton v-if="isLoadingPredictionTraffic" type="card" />
    <div v-if="!isLoadingPredictionTraffic">
      <span class="interactive-map-traffic-title"> Análise do Tráfego</span>
      <span v-if="predictTrafficData.trend === 'up'" class="interactive-map-traffic-text"
        >Durante o período analisado, observamos um aumento significativo no tráfego turístico na
        região. As principais conclusões e tendências identificadas são as seguintes:</span
      >
      <span v-if="predictTrafficData.trend === 'down'" class="interactive-map-traffic-text"
        >Durante o período analisado, observamos uma diminuição significativa no tráfego turístico
        na região. As principais conclusões e tendências identificadas são as seguintes:</span
      >
      <div
        v-for="(value, key) in filteredPredictTrafficData"
        :key="key"
        class="interactive-map-traffic-block-text"
      >
        <!-- <img src="/caret-down.svg" alt="" /> -->
        <div class="interactive-map-traffic-sub-block-text">
          <span class="interactive-map-traffic-subtitle">{{ translateKey(key) }}</span>
          <span class="interactive-map-traffic-text">{{ value }}</span>
        </div>
      </div>
      <span class="interactive-map-traffic-subtitle" style="margin: 15px 0">Legenda:</span>

      <div class="interactive-map-traffic-block-text">
        <img src="/legend-icon.svg" alt="" style="margin-top: 1px !important" />
        <div class="interactive-map-traffic-sub-block-text">
          <span class="interactive-map-traffic-title">Via interditada</span>
          <span class="interactive-map-traffic-text"
            >Pode causar atrasos na chegada em Aeroporto Internacional de Foz do Iguaçu.</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useInteractiveMap } from '../../../../../../../stores/interactiveMap'
import { useCustomHeader } from '../../../../../../../stores/customHeader'
import CustomSkeleton from '@/Shared/CustomSkeleton'
import { mapState } from 'pinia'
export default {
  name: 'Traffic',
  components: {
    CustomSkeleton,
  },
  data() {
    return {
      translations: {
        accommodationPreferences: 'Preferências de Acomodação',
        commerce: 'Comércio',
        currencyExchange: 'Variação do Câmbio',
        exchangeRate: 'Variação do Câmbio',
        events: 'Eventos',
        favoriteAttractions: 'Atrações Favoritas',
        foreignTouristFlow: 'Fluxo de Turistas Estrangeiros',
        gastronomy: 'Gastronomia',
        hotelOccupancy: 'Taxa de Ocupação Hoteleira',
        hotelOccupancyByCategory: 'Taxa de Ocupação Hoteleira por Categoria',
        lodging: 'Hospedagem',
        nightlife: 'Vida Noturna',
        tour: 'Turismo',
        transport: 'Transporte',
        transportPreferences: 'Preferências de Transporte',
        weatherForecast: 'Previsão do Tempo',
        climateForecast: 'Previsão do Tempo',
      },
    }
  },
  computed: {
    ...mapState(useCustomHeader, ['getSubtitleCustomHeader']),
    ...mapState(useCustomHeader, ['getSelectedButtonId']),
    ...mapState(useCustomHeader, ['isLoadingPredictionTraffic']),
    ...mapState(useInteractiveMap, ['predictTrafficData']),
    filteredPredictTrafficData() {
      const { trend, summary, ...rest } = this.predictTrafficData
      return rest
    },
  },
  mounted() {
    this.getSubtitleCustomHeader('Dados em tempo real')
    this.getSelectedButtonId(2)
  },
  methods: {
    translateKey(key) {
      return this.translations[key] || key
    },
  },
}
</script>

<style src="./styles.css"></style>
